/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-mixins */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import { mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class MyFeedController extends Controller.extend(EditPostMixin) {
  queryParams = ['offset'];
  offset = 0;
  PostTypes = PostTypes;

  @computed('model.feed.@each.isRead')
  get readPostIds() {
    return mapBy(
      this.model.feed.filter((item) => item.isRead),
      'entityId',
    );
  }

  @action
  nextPage() {
    this.incrementProperty('offset', 20);
  }

  @action
  prevPage() {
    this.decrementProperty('offset', 20);
  }
}
